import successIcon from '../icons/assets/radiobutton-selected.svg';
import errorIcon from '../icons/assets/error.svg';

const ATTRIBUTE_ALERT = 'data-klt-c-alert';
const ATTRIBUTE_ALERT_CLOSE = 'data-klt-c-alert-close';

const CLASS_ALERT_HIDDEN = 'klt-c-alert--hidden';
const CLASS_ALERT_JS_INITALIZED = 'klt-c-alert--js';
const TOAST_TIMEOUT = 5000; // miliseconds

const timers = [];

export enum AlertType {
    Info = 'info',
    Error = 'error',
    Success = 'success'
}

const alertIcon = {
    success: successIcon,
    error: errorIcon
};

export type AlertProps = {
    title?: string;
    message?: string;
};

// TODO: Replace by importing the Twig template if somehow possible
const templateTitle = (title: string, type: AlertType) => `
    <p class="klt-c-alert__title">
        <span class="klt-c-icon klt-c-icon--${type.toString()} " data-klt-icon-name="${type.toString()}" aria-hidden="true">
            ${alertIcon[type.toString()]}
        </span>
        <strong>${title}</strong>
    </p>
    `;

// TODO: Replace by importing the Twig template if somehow possible
const templateMessage = (message: string) => `
    <p class="klt-c-alert__message">
        ${message}
    </p>
    `;

// TODO: Replace by importing the Twig template if somehow possible
const template = (props: AlertProps, type: AlertType) => `
    <div class="klt-c-alert-toast-wrapper">
        <div class="klt-c-alert klt-c-alert--${type.toString()} klt-c-alert--toast" data-klt-c-alert>
            ${props.title ? templateTitle(props.title, type) : ''}
            ${props.message ? templateMessage(props.message) : ''}
            <button class="klt-c-alert__close-action" data-klt-c-alert-close>
                <span class="klt-c-icon-labeled ">
                    <span class="klt-c-icon klt-c-icon--close " data-klt-icon-name="close" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                            <path fill="#000000" fill-rule="evenodd"
                                d="M11.0171733,8.89585295 L2.64209451,0.520774171 C1.99577063,-0.125549711 0.996095253,-0.174952095 0.410571579,0.410571579 L0.410571579,0.410571579 C-0.179439378,1.00058254 -0.125570924,1.99574942 0.520774171,2.64209451 L8.89585295,11.0171733 L0.520774171,19.3922521 C-0.125549711,20.038576 -0.174952095,21.0382513 0.410571579,21.623775 L0.410571579,21.623775 C1.00058254,22.213786 1.99574942,22.1599175 2.64209451,21.5135724 L11.0171733,13.1384936 L19.3922521,21.5135724 C20.038576,22.1598963 21.0382513,22.2092987 21.623775,21.623775 C22.213786,21.0337641 22.1599175,20.0385972 21.5135724,19.3922521 L13.1384936,11.0171733 L21.5135724,2.64209451 C22.1598963,1.99577063 22.2092987,0.996095253 21.623775,0.410571579 C21.0337641,-0.179439378 20.0385972,-0.125570924 19.3922521,0.520774171 L11.0171733,8.89585295 Z" />
                        </svg>
                    </span>
                    <span class="klt-c-icon-label">
                        Close
                    </span>
                </span>
            </button>
        </div>
    </div>
`;

export default function init(closeAfter?: number) {
    try {
        const alertElements = document.querySelectorAll(`[${ATTRIBUTE_ALERT}]:not(.${CLASS_ALERT_JS_INITALIZED})`);
        if (alertElements.length > 0) {
            for (let i = 0; i < alertElements.length; i++) {
                const alert = alertElements[i];
                const closeAction = alert.querySelector(`[${ATTRIBUTE_ALERT_CLOSE}]`);

                const closeHandler = () => {
                    alert.setAttribute('aria-hidden', 'true');
                    alert.classList.add(`${CLASS_ALERT_HIDDEN}`);

                    if (closeAction) {
                        closeAction.removeEventListener('click', closeHandler);
                    }

                    timers.forEach(timer => clearTimeout(timer));
                    alert.remove();
                };

                if (closeAction) {
                    alert.classList.add(`${CLASS_ALERT_JS_INITALIZED}`);
                    closeAction.removeAttribute('hidden');
                    closeAction.addEventListener('click', closeHandler);
                }

                if (closeAfter) {
                    timers.push(setTimeout(closeHandler, closeAfter));
                }
            }
        }
    } catch (e) {
        console.error(`Couldn't initalize alerts module.`, e);
    }
}

export function showToastAlert(props: AlertProps, type = AlertType.Info) {
    const elements = document.getElementsByTagName('main');

    if (elements.length > 0) {
        const contentBody = elements[0];
        contentBody.insertAdjacentHTML('afterbegin', template(props, type));
        init(TOAST_TIMEOUT);
    }
}

export function clearToastAlerts() {
    const elements = document.getElementsByTagName('main');
    timers.forEach(timer => clearTimeout(timer));

    if (elements.length > 0) {
        const contentBody = elements[0];
        const alertElements = contentBody.querySelectorAll(`[${ATTRIBUTE_ALERT}]`);

        alertElements.forEach(element => {
            element.remove();
        });
    }
}
